import React, { useMemo } from 'react';
import { TableCell, TableRow, Typography } from "@mui/material";
import moment from "moment/moment";

const PromptTableItem = ({ item, onSelect }) => {
  // Define category mappings
  const categoryMap = useMemo(() => ({
    "ARTICLES": "Articles",
    "SINGLE_POST": "Single Post",
    "ARTICLE_TITLES": "Article Titles",
    "ARTICLE_TAGLINES": "Article Taglines",
    "BANNER_TITLES": "Banner Titles",
    "NEWS": "News",
    "WEEKLY_NEWS": "Weekly News"
  }), []);

  const subCategoryMap = useMemo(() => ({
    "PROMPT": "Prompt",
    "FORMAT": "Format",
    "SUB_FORMAT": "Sub Format"
  }), []);

  return (
      <TableRow
          onClick={() => onSelect(item)}
          sx={{
            "&.MuiTableRow-root": {
              border: "1px solid #E7E9EE",
              backgroundColor: "#F9FAFB",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#dec7f6"
              },
              boxShadow: "0px 0px 1px rgba(12, 26, 75, 0.1), 0px 4px 8px rgba(20, 37, 63, 0.04)"
            },
            "& .MuiTableCell-root": {
              padding: "12px",
              fontSize: "0.85rem"
            }
          }}
      >
        <TableCell align={"left"}>
          <Typography
            fontWeight={600}
            fontSize="0.9rem"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
          >
            {item.name}
          </Typography>
        </TableCell>
        <TableCell align={"center"}>
          {categoryMap[item.category] || "Unknown"}
        </TableCell>
        <TableCell align={"center"}>
          {subCategoryMap[item.type] || "Unknown"}
        </TableCell>
        <TableCell align={"center"}>
          <Typography
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: "0.85rem"
            }}
          >
            {item.formatName || ""}
          </Typography>
        </TableCell>
        <TableCell align="center">
          {moment(item.createdDate).format("DD/MM/YY")}
        </TableCell>
      </TableRow>
  );
};

export default PromptTableItem;
